<app-tool-bar *ngIf="!hideToolbar"></app-tool-bar>
<app-breadcrumb *ngIf="!hideToolbar"></app-breadcrumb>
<div class="router-outlet-wrapper mat-typography" [ngClass]="{'max-height': !hideToolbar}">
    <router-outlet></router-outlet>
</div>
<app-banner *ngIf="showBanner"></app-banner>
<app-footer *ngIf="showFooter"></app-footer>
